import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar } from '@material-ui/core';
import { useRouteMatch } from 'react-router';
import clsx from 'clsx';

import FormResetWithConfirm from '../form-reset/FormResetWithConfirm';
import { CheckIcon, TimesIcon } from '../icon/solid';
import FormReset from '../form-reset/FormReset';
import FormSubmit from '../form-submit/FormSubmit';
import useStyles from './styles';
import { setAllowChangeProjectStatus } from '../../store/modules/projects/actions';
import { useDispatch } from 'react-redux';

export const CONTROLS_CONTAINER_HEIGHT = 72;

type Props = {
  preventCancelChanges: boolean;
  dirty: boolean;
  isSubmitting: boolean;
  creatingMode: boolean;
  loading: boolean;
  disableSubmit: boolean;
  postText: string;
  position?: 'fixed' | 'absolute' | 'sticky' | 'static' | 'relative';
};

const ItemFormControls = ({
  preventCancelChanges,
  dirty,
  isSubmitting,
  creatingMode,
  loading,
  disableSubmit,
  postText,
  position = 'fixed',
}: Props) => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const videoMenuRoute = 'dashboard/admin/video-menus';
  const [useCustomPadding, setUseCustomPadding] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setAllowChangeProjectStatus(!dirty));

    return () => {
      dispatch(setAllowChangeProjectStatus(true));
    };
  }, [dispatch, dirty]);

  useEffect(() => {
    if (path.indexOf(videoMenuRoute) > -1) {
      setUseCustomPadding(true);
    } else {
      setUseCustomPadding(false);
    }
  }, [path, videoMenuRoute, setUseCustomPadding]);

  return (
    <div style={{ height: CONTROLS_CONTAINER_HEIGHT }}>
      <AppBar
        position={position}
        className={clsx(classes.panel, {
          [classes.panelFixed]: position !== 'relative',
          [classes.panelForVideoMenu]: (useCustomPadding),
        })}
      >
        <Toolbar className={classes.toolbar}>
          <FormSubmit
            className={classes.panelButton}
            variant="contained"
            color="primary"
            disabled={loading || disableSubmit}
            withHotkey
            data-intercom-target="Save button"
          >
            <CheckIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>
              {postText}
            </span>
          </FormSubmit>
          {
            preventCancelChanges
              ? (
                <FormResetWithConfirm
                  className={clsx(classes.cancelButton, classes.panelButton)}
                  variant="contained"
                  color="default"
                  withHotkey
                  data-intercom-target="Cancel button"
                  preventCancelChanges={preventCancelChanges && dirty && !isSubmitting}
                  dirty={dirty}
                  creatingMode={creatingMode}
                >
                  <TimesIcon className={classes.buttonIcon} />
                  <span className={classes.buttonText}>Cancel</span>
                </FormResetWithConfirm>
              )
              : (
                <FormReset
                  className={clsx(classes.cancelButton, classes.panelButton)}
                  variant="contained"
                  color="default"
                  withHotkey
                  data-intercom-target="Cancel button"
                >
                  <TimesIcon className={classes.buttonIcon} />
                  <span className={classes.buttonText}>Cancel</span>
                </FormReset>
              )
          }
        </Toolbar>
      </AppBar>
      { position === 'fixed' && <div className={classes.backLine} /> }
    </div>
  );
};

export default ItemFormControls;
